var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currency-display"},[_vm._v("\n    "+_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm._f("currency")(_vm.amount,_vm.decimalsApply, _vm.applyConvertion))+"\n    "),(_vm.showCurrencyCode)?_c('span',{style:({ fontSize: _vm.reduceIsoFont ? '1rem' : '' })},[_vm._v(_vm._s(_vm.currencyCodeMain))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }